
export const serverAppConfig = {
  "storeId": "62b43c83052ce4126af4112a",
  "categories": [
    {
      "id": "638a00f4f5d2751aa6636fa1",
      "name": "Makeup",
      "slug": "makeup",
      "description": "Makeup för alla",
      "thumbnailDescription": "Utforska makeup som passar alla hudtyper och stilar med våra experttips.",
      "additionalText": "<p>Oavsett om du är nybörjare eller en erfaren makeup-artist, erbjuder vår guide allt du behöver veta för att skapa en look som är både vacker och hållbar. Från foundation till läppstift, vi täcker alla aspekter av makeup för att hjälpa dig att uttrycka din unika stil. Lär dig om de senaste trenderna och hur du anpassar dem till din vardag. Vår sida är din ultimata resurs för makeup-inspiration och råd.</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/makeup.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/m1.jpeg",
      "order": 1,
      "metaTitle": "Makeup för Alla: Din Guide till Perfekt Makeup",
      "metaDescription": "Upptäck de bästa tipsen och produkterna för att skapa en fantastisk makeup-look som passar alla hudtyper och stilar.",
      "metaHeader": "Makeup för Alla: Skönhet utan Gränser",
      "subCategories": [
        {
          "id": "638a00fbf5d2751aa6636fa2",
          "name": "Eyes",
          "slug": "makeup-eyes",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/eyes.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/e1.jpeg",
          "order": 1,
          "metaTitle": "Eye makeup",
          "metaDescription": "",
          "metaHeader": "Eye makeup",
          "subCategories": [
            {
              "id": "63da35fe3d75bf4e9837fee5",
              "name": "Eyeshadow",
              "slug": "makeup-eyes-eyeshadow",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/eyeshadow.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/e4.jpeg",
              "order": 1,
              "metaTitle": "Eyeshadow",
              "metaDescription": "",
              "metaHeader": "Eyeshadow",
              "subCategories": null
            },
            {
              "id": "63da36193d75bf4e9837fee6",
              "name": "Eyeliner",
              "slug": "makeup-eyes-eyeliner",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/eyeliner.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/e6.jpeg",
              "order": 2,
              "metaTitle": "Eyeliner",
              "metaDescription": "",
              "metaHeader": "Eyeliner",
              "subCategories": null
            },
            {
              "id": "63da36223d75bf4e9837fee7",
              "name": "Mascara",
              "slug": "makeup-eyes-mascara",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/mascara.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/e8.jpeg",
              "order": 3,
              "metaTitle": "Mascara",
              "metaDescription": "",
              "metaHeader": "Mascara",
              "subCategories": null
            }
          ]
        },
        {
          "id": "63da33eb3d75bf4e9837fed0",
          "name": "Face",
          "slug": "makeup-face",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/face.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/f2.jpeg",
          "order": 2,
          "metaTitle": "Face makeup",
          "metaDescription": "",
          "metaHeader": "Face makeup",
          "subCategories": [
            {
              "id": "63da34063d75bf4e9837fed3",
              "name": "Primer",
              "slug": "makeup-face-primer",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p2.jpeg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p1.jpeg",
              "order": 1,
              "metaTitle": "Primer",
              "metaDescription": "",
              "metaHeader": "Primer",
              "subCategories": null
            },
            {
              "id": "63da340e3d75bf4e9837fed4",
              "name": "Foundation",
              "slug": "makeup-face-foundation",
              "description": "",
              "thumbnailDescription": "Upptäck hur foundation kan förvandla ditt ansikte till en magisk canvas!",
              "additionalText": "<p>Hej där, små makeup-äventyrare! Visste ni att foundation är som en magisk trollstav för ditt ansikte? Det hjälper till att jämna ut din hudton och ger dig en perfekt bas för att skapa alla möjliga roliga och färgglada sminkningar. Föreställ dig att du är en konstnär och ditt ansikte är din canvas. Med rätt foundation kan du skapa allt från en glittrande enhörning till en mystisk superhjälte! Så ta fram dina penslar och svampar, och låt oss börja vårt magiska makeup-äventyr!</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/foundation.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/f4.jpeg",
              "order": 2,
              "metaTitle": "Magiska Makeup-Äventyr: Upptäck Foundationens Hemligheter!",
              "metaDescription": "Dyk in i en värld av färger och glitter med vår guide till makeup och foundation! Lär dig hur du kan förvandla ditt ansikte till en magisk canvas och ha kul medan du gör det!",
              "metaHeader": "Foundationens Fantastiska Värld",
              "subCategories": null
            },
            {
              "id": "63da34143d75bf4e9837fed5",
              "name": "Concealer",
              "slug": "makeup-face-concealer",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/c1.webp",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/c2.webp",
              "order": 3,
              "metaTitle": "Concealer",
              "metaDescription": "",
              "metaHeader": "Concealer",
              "subCategories": null
            },
            {
              "id": "63da34243d75bf4e9837fed6",
              "name": "Powder",
              "slug": "makeup-face-powder",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/powder.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p3.jpeg",
              "order": 4,
              "metaTitle": "Face powder",
              "metaDescription": "",
              "metaHeader": "Face powder",
              "subCategories": null
            },
            {
              "id": "63da34323d75bf4e9837fed7",
              "name": "Setting spray",
              "slug": "makeup-face-setting-spray",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/settingspray.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/s2.jpeg",
              "order": 5,
              "metaTitle": "Setting spray",
              "metaDescription": "",
              "metaHeader": "Setting spray",
              "subCategories": null
            },
            {
              "id": "63da344a3d75bf4e9837fed8",
              "name": "Blush",
              "slug": "makeup-face-blush",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/blush.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/b2.jpeg",
              "order": 6,
              "metaTitle": "Blush",
              "metaDescription": "",
              "metaHeader": "Blush",
              "subCategories": null
            },
            {
              "id": "63da345e3d75bf4e9837fed9",
              "name": "Bronzer",
              "slug": "makeup-face-bronzer",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/highlighter.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/b4.jpeg",
              "order": 7,
              "metaTitle": "Bronzer",
              "metaDescription": "",
              "metaHeader": "Bronzer",
              "subCategories": null
            },
            {
              "id": "63da34793d75bf4e9837feda",
              "name": "Contour",
              "slug": "makeup-face-contour",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/contourbanner_720.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/c4.jpeg",
              "order": 8,
              "metaTitle": "Contour ",
              "metaDescription": "",
              "metaHeader": "Contour",
              "subCategories": null
            },
            {
              "id": "63dba3ab3d75bf4e9837ffd9",
              "name": "Color Correcting",
              "slug": "makeup-face-color-correcting",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/colorcorrectingbanner__2__720.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/c6.jpeg",
              "order": 9,
              "metaTitle": "Color correcting",
              "metaDescription": "",
              "metaHeader": "Color correcting",
              "subCategories": null
            },
            {
              "id": "63dba6d43d75bf4e9837ffda",
              "name": "Highlighter",
              "slug": "makeup-face-highlighter",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/highlighter2.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/h2.jpeg",
              "order": 10,
              "metaTitle": "Highlighter",
              "metaDescription": "",
              "metaHeader": "Highlighter",
              "subCategories": null
            }
          ]
        },
        {
          "id": "63da33fc3d75bf4e9837fed2",
          "name": "Brushes",
          "slug": "makeup-brushes",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/brushes.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/b6.jpeg",
          "order": 4,
          "metaTitle": "Makeup brushes",
          "metaDescription": "",
          "metaHeader": "Makeup brushes",
          "subCategories": null
        },
        {
          "id": "63da348c3d75bf4e9837fedb",
          "name": "Lips",
          "slug": "makeup-lips",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/lips.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/l1.jpeg",
          "order": 3,
          "metaTitle": "Lips",
          "metaDescription": "",
          "metaHeader": "Lips",
          "subCategories": [
            {
              "id": "63da349b3d75bf4e9837fedc",
              "name": "Lip Liner",
              "slug": "makeup-lips-lip-liner",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/lipliner.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/l2.jpeg",
              "order": 1,
              "metaTitle": "Lip liner",
              "metaDescription": "",
              "metaHeader": "Lip liner",
              "subCategories": null
            },
            {
              "id": "63da34a33d75bf4e9837fedd",
              "name": "Lipstick",
              "slug": "makeup-lips-lipstick",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/lipstick.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/l6.jpeg",
              "order": 2,
              "metaTitle": "Lipstick",
              "metaDescription": "",
              "metaHeader": "Lipstick",
              "subCategories": null
            },
            {
              "id": "63da34b23d75bf4e9837fede",
              "name": "Lipgloss",
              "slug": "makeup-lips-lipgloss",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/lipgloss.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/l8.jpeg",
              "order": 3,
              "metaTitle": "Lipgloss",
              "metaDescription": "",
              "metaHeader": "Lipgloss",
              "subCategories": null
            }
          ]
        },
        {
          "id": "63da5e483d75bf4e9837ff23",
          "name": "Tools",
          "slug": "makeup-tools",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/tools.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/t2.jpeg",
          "order": 5,
          "metaTitle": "Makeup tools",
          "metaDescription": "",
          "metaHeader": "Makeup tools",
          "subCategories": null
        },
        {
          "id": "63da5eba3d75bf4e9837ff2d",
          "name": "Eyebrows",
          "slug": "makeup-eyebrows",
          "description": "my eyebrows category",
          "thumbnailDescription": "Fånga sommarens strålar med perfekt formade ögonbryn. Lär dig hur!",
          "additionalText": "<p>Sommaren är här och det är dags att låta dina ögonbryn stråla i solen! Med rätt teknik och produkter kan du skapa en look som är både naturlig och hållbar. Oavsett om du föredrar en mjuk och naturlig stil eller en mer definierad look, har vi tipsen och tricken för att du ska lyckas. Utforska vår kategori för makeup-ögonbryn och hitta dina nya favoriter för sommaren!</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/eyebrows.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nedladdning.jpeg",
          "order": 6,
          "metaTitle": "Perfekta Sommarbryn: Din Guide till Makeup för Ögonbryn",
          "metaDescription": "Upptäck hemligheterna bakom sommarens mest eftertraktade ögonbryn. Lär dig tekniker och produkter för att skapa naturligt vackra bryn som håller hela dagen.",
          "metaHeader": "Sommarens Guide till Perfekta Ögonbryn",
          "subCategories": [
            {
              "id": "63da5ec93d75bf4e9837ff2e",
              "name": "Eyebrowgel",
              "slug": "makeup-eyebrows-eyebrowgel",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/eyebrowgel.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nedladdning (1).jpeg",
              "order": 1,
              "metaTitle": "Eyebrow gel",
              "metaDescription": "",
              "metaHeader": "Eyebrow gel",
              "subCategories": null
            },
            {
              "id": "63da5f1b3d75bf4e9837ff31",
              "name": "Eyebrow Tint",
              "slug": "makeup-eyebrows-eyebrow-tint",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/eyebrowtint.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images.jpeg",
              "order": 2,
              "metaTitle": "Eyebrow Tint",
              "metaDescription": "",
              "metaHeader": "Eyebrow Tint",
              "subCategories": null
            },
            {
              "id": "63da5f2f3d75bf4e9837ff32",
              "name": "Eyebrow Pencil",
              "slug": "makeup-eyebrows-eyebrow-pencil",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/eyebrowpencil.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (1).jpeg",
              "order": 3,
              "metaTitle": "Eyebrow Pencil",
              "metaDescription": "",
              "metaHeader": "Eyebrow Pencil",
              "subCategories": null
            }
          ]
        },
        {
          "id": "63db60413d75bf4e9837ffa3",
          "name": "Palette",
          "slug": "makeup-palette",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/palette.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (2).jpeg",
          "order": 7,
          "metaTitle": "Palette",
          "metaDescription": "",
          "metaHeader": "Palette",
          "subCategories": [
            {
              "id": "63db60493d75bf4e9837ffa4",
              "name": "Face Palette",
              "slug": "makeup-palette-face-palette",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/facepalette.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (2).jpeg",
              "order": 1,
              "metaTitle": "",
              "metaDescription": "",
              "metaHeader": "",
              "subCategories": null
            },
            {
              "id": "63db60513d75bf4e9837ffa5",
              "name": "Eyes Palette",
              "slug": "makeup-palette-eyes-palette",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/eyepalette.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (2).jpeg",
              "order": 2,
              "metaTitle": "",
              "metaDescription": "",
              "metaHeader": "",
              "subCategories": null
            }
          ]
        }
      ]
    },
    {
      "id": "63d7b6353d75bf4e9837febc",
      "name": "Table setting & Serving",
      "slug": "table-setting-serving",
      "description": "Make time in the kitchen pleasant and inspiring with the right kind of kitchen details and utensils. Create inviting table settings with porcelain, cutlery and glasses in Scandinavian design!",
      "thumbnailDescription": "",
      "additionalText": "",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_11232-07-02-eb8ca3b7c1.webp",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/ripple-glas-karaff-galleri-1-77fad5c963.webp",
      "order": 3,
      "metaTitle": "Everything in Table setting & Serving ",
      "metaDescription": "",
      "metaHeader": "Table setting & Serving ",
      "subCategories": [
        {
          "id": "63d7b63b3d75bf4e9837febd",
          "name": "Glasses",
          "slug": "table-setting-serving-glasses",
          "description": "We have a wide range of champagne glasses, cocktail glasses, drinking glasses, drinking glasses, schnapps glasses, whiskey glasses, cognac glasses, wine glasses and beer glasses from well-known brands such as Iittala, Orrefors and Holmegaard.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/37510-01-02-d08cadf839.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/37510-01-02-d08cadf839.webp",
          "order": 1,
          "metaTitle": "Glasses",
          "metaDescription": "",
          "metaHeader": "Glasses",
          "subCategories": [
            {
              "id": "63d7b6873d75bf4e9837fec1",
              "name": "Wine Glasses",
              "slug": "table-setting-serving-glasses-wine-glasses",
              "description": "The right type of wine glass for the wine can make the aromas and flavors of the drink bloom even more, and enhance the entire drinking experience. But which shape of the glasses fits best and what differentiates the glasses? Here we have collected the best selection of different types of wine glasses and answer all your questions.",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/571582-01_40_EnvironmentImage-25c9e59e9b (1).webp",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/571582-01_41_EnvironmentImage-3003919923.webp",
              "order": 1,
              "metaTitle": "Wine Glasses",
              "metaDescription": "",
              "metaHeader": "Wine Glasses",
              "subCategories": null
            },
            {
              "id": "63da43e73d75bf4e9837fee9",
              "name": "Cocktail Glasses",
              "slug": "table-setting-serving-glasses-cocktail-glasses",
              "description": "Serving the tasty drink in style enhances the feeling! With us you will find several cocktail glasses in different models and sizes from many well-known brands. Welcome to us to find your new cocktail glasses!",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_32075-01-02-9bbccca78d.webp",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/507170-01_4_EnvironmentImage-a7e4c244d7.webp",
              "order": 3,
              "metaTitle": "Cocktail Glasses",
              "metaDescription": "",
              "metaHeader": "Cocktail Glasses",
              "subCategories": null
            },
            {
              "id": "63da73703d75bf4e9837ff7a",
              "name": "Water Glasses",
              "slug": "table-setting-serving-glasses-water-glasses",
              "description": "Brighten up meals with well-designed, high-quality drinking glasses. The glass has a given place on the dining table, regardless of whether it is for the weekday dinner or the weekend party!",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/37510-01-02-d08cadf839.webp",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/504543-01_4_EnvironmentImage-44ee501e83.webp",
              "order": 4,
              "metaTitle": "Water Glasses",
              "metaDescription": "",
              "metaHeader": "Water Glasses",
              "subCategories": null
            },
            {
              "id": "63db86093d75bf4e9837ffc9",
              "name": "Beer Glasses",
              "slug": "table-setting-serving-glasses-beer-glasses",
              "description": "Beer glasses are available in many different shapes and variants, adapted for different types of beer. Don't know which beer glass to choose? No danger! Here you will find both a wide selection of stylish beer glasses on foot, large beer glasses and narrow beer glasses together with a guide for which glass suits you best!",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/507165-01_5_EnvironmentImage-1d438b20a7.webp",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_20840-01-03-f526ece6fa.webp",
              "order": 5,
              "metaTitle": "Beer Glasses",
              "metaDescription": "",
              "metaHeader": "Beer Glasses",
              "subCategories": null
            },
            {
              "id": "63db86123d75bf4e9837ffca",
              "name": "Drink Glasses",
              "slug": "table-setting-serving-glasses-drink-glasses",
              "description": "Serve the drink in style! Here you will find mixed drinking glasses from well-known brands. We have mixed classic design with contemporary so that there is something for everyone. Find your favorite and invite to a drink night!",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/43740-01-02-2d5f4b91b3.webp",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_31545-01-04-ba179f2238.webp",
              "order": 6,
              "metaTitle": "Drink Glasses",
              "metaDescription": "",
              "metaHeader": "Drink Glasses",
              "subCategories": null
            }
          ]
        },
        {
          "id": "63d7b69d3d75bf4e9837fec2",
          "name": "Bowls",
          "slug": "table-setting-serving-bowls",
          "description": "Serve food neatly and elegantly with practical serving bowls and beautiful dishes. With us you will find everything you could possibly need to create tasteful layouts.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/23722-02_2_EnvironmentImage-f73b092d2c.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/23721-02_5_EnvironmentImage-eaebd2b964.webp",
          "order": 2,
          "metaTitle": "Bowls",
          "metaDescription": "",
          "metaHeader": "Bowls",
          "subCategories": null
        },
        {
          "id": "63da44163d75bf4e9837feea",
          "name": "Plates",
          "slug": "table-setting-serving-plates",
          "description": "Plates in good quality and stylish design are a must for every home. In addition to its obvious functionality, the plate is a detail that can lift your entire table setting and also enhance the flavors of the meal, since you also \"eat with your eyes\". Here you will find the best selection of fine plates in different models and sizes.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/47377-03_10_EnvironmentImage-8482d7087c.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/23721-02-02_01-65754acbf9.webp",
          "order": 3,
          "metaTitle": "Plates",
          "metaDescription": "",
          "metaHeader": "Plates",
          "subCategories": [
            {
              "id": "63db7b773d75bf4e9837ffbc",
              "name": "Small plates",
              "slug": "table-setting-serving-plates-small-plates",
              "description": "Here you will find plates from popular series such as Swedish Grace and Mon Amie.",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/23721-02-02_01-65754acbf9.webp",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/23721-02_5_EnvironmentImage-eaebd2b964.webp",
              "order": 1,
              "metaTitle": "Small plates",
              "metaDescription": "",
              "metaHeader": "Small plates",
              "subCategories": null
            },
            {
              "id": "63db7d783d75bf4e9837ffc0",
              "name": "Soup Plates",
              "slug": "table-setting-serving-plates-soup-plates",
              "description": "Here you will find deep plates from popular series such as Swedish Grace, Rustic and Nordic Sand.",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/45426-02-03-f23547d1ae.webp",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/31380-01_2_EnvironmentImage-fe9c6923f7.webp",
              "order": 2,
              "metaTitle": "Soup Plates",
              "metaDescription": "",
              "metaHeader": "Soup Plates",
              "subCategories": null
            }
          ]
        },
        {
          "id": "63da443c3d75bf4e9837feeb",
          "name": "Cups & Mugs",
          "slug": "table-setting-serving-cups-mugs",
          "description": "With a beautiful cup or mug, you brighten up coffee time every day. Rustic or elegant? Here are cups and mugs in all styles so that you can easily find your favourite!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/46172-03_6_EnvironmentImage_2-3fc29bdf22.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/37162-04_2_ProductImageExtra-be03f050d6.webp",
          "order": 4,
          "metaTitle": "Cups & Mugs",
          "metaDescription": "",
          "metaHeader": "Cups & Mugs",
          "subCategories": null
        },
        {
          "id": "63da45053d75bf4e9837fef1",
          "name": "Decanters",
          "slug": "table-setting-serving-decanters",
          "description": "Offer your guests water in a fancy water carafe or jug. The decanter is often placed in the middle of the table and is therefore an important detail in beautiful table setting. We have a wide range of jugs, water carafes and jugs both with and without lids from well-known brands in stylish designs.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/510600-01_4_EnvironmentImage-4948308f25.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/ripple-glas-karaff-galleri-1-77fad5c963.webp",
          "order": 5,
          "metaTitle": "Decanters",
          "metaDescription": "",
          "metaHeader": "Decanters",
          "subCategories": null
        },
        {
          "id": "63da5ac93d75bf4e9837ff06",
          "name": "Pots",
          "slug": "table-setting-serving-pots",
          "description": "Serve tea in a practical teapot that is also beautiful to display on the table. Here you will find both large and small porcelain or glass teapots from well-known brands such as Bodum and Höganäs.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/46172-05-05-809ee9a6fa.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/46172-03_6_EnvironmentImage_2-3fc29bdf22.webp",
          "order": 6,
          "metaTitle": "Teapots",
          "metaDescription": "",
          "metaHeader": "Teapots",
          "subCategories": null
        }
      ]
    },
    {
      "id": "63da28363d75bf4e9837fec5",
      "name": "Skincare",
      "slug": "skincare",
      "description": "Skincare routine for everyone",
      "thumbnailDescription": "Achieve a sun-kissed glow with our all-inclusive skincare routine. Perfect for every skin type, this guide is your ticket to radiant skin.",
      "additionalText": "<p>Step into the sunshine with confidence and a radiant complexion. Our skincare routine is designed to cater to all skin types, ensuring everyone can enjoy the benefits of healthy, glowing skin. From gentle cleansers to nourishing moisturizers, we've got you covered. Embrace the warmth of summer with skin that shines as bright as the sun!</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/skincare.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (4).jpeg",
      "order": 2,
      "metaTitle": "Radiant Skin for All: Your Ultimate Skincare Routine",
      "metaDescription": "Discover the secrets to glowing skin with our inclusive skincare routine. Perfect for every skin type, our guide ensures you achieve a luminous complexion effortlessly. Embrace the summer glow with confidence!",
      "metaHeader": "Unlock Your Radiant Glow: Skincare for Everyone",
      "subCategories": [
        {
          "id": "63da28483d75bf4e9837fec6",
          "name": "Moisturizer",
          "slug": "skincare-moisturizer",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/cream.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (5).jpeg",
          "order": 1,
          "metaTitle": "Moisturizer",
          "metaDescription": "",
          "metaHeader": "Moisturizer",
          "subCategories": null
        },
        {
          "id": "63da32b73d75bf4e9837fec9",
          "name": "Serum",
          "slug": "skincare-serum",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/serum.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nedladdning (2).jpeg",
          "order": 2,
          "metaTitle": "Serum",
          "metaDescription": "",
          "metaHeader": "Serum",
          "subCategories": null
        },
        {
          "id": "63da32fc3d75bf4e9837feca",
          "name": "Cleanser",
          "slug": "skincare-cleanser",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/cleanser.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (3).jpeg",
          "order": 3,
          "metaTitle": "Cleanser",
          "metaDescription": "",
          "metaHeader": "Cleanser",
          "subCategories": null
        }
      ]
    },
    {
      "id": "63da339e3d75bf4e9837fecd",
      "name": "Nails",
      "slug": "nails",
      "description": "",
      "thumbnailDescription": "",
      "additionalText": "",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nails.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nedladdning (3).jpeg",
      "order": 7,
      "metaTitle": "Nails",
      "metaDescription": "",
      "metaHeader": "Nails",
      "subCategories": [
        {
          "id": "63da33a63d75bf4e9837fece",
          "name": "Nail Polish",
          "slug": "nails-nail-polish",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nails2.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nedladdning (4).jpeg",
          "order": 1,
          "metaTitle": "Nail Polish",
          "metaDescription": "",
          "metaHeader": "Nail Polish",
          "subCategories": [
            {
              "id": "63da5fd03d75bf4e9837ff3b",
              "name": "Gel Polish",
              "slug": "nails-nail-polish-gel-polish",
              "description": "",
              "thumbnailDescription": "",
              "additionalText": "",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nails2.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nedladdning (4).jpeg",
              "order": 1,
              "metaTitle": "Gel Polish",
              "metaDescription": "",
              "metaHeader": "Gel Polish",
              "subCategories": null
            }
          ]
        },
        {
          "id": "63da33d93d75bf4e9837fecf",
          "name": "Tools",
          "slug": "nails-tools",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nails3.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nedladdning (5).jpeg",
          "order": 2,
          "metaTitle": "Tools",
          "metaDescription": "",
          "metaHeader": "Tools",
          "subCategories": null
        },
        {
          "id": "63da60d53d75bf4e9837ff41",
          "name": "Nail Polish Remover",
          "slug": "nails-nail-polish-remover",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nails4.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/nedladdning (6).jpeg",
          "order": 3,
          "metaTitle": "Nail Polish Remover",
          "metaDescription": "",
          "metaHeader": "Nail Polish Remover",
          "subCategories": null
        }
      ]
    },
    {
      "id": "63da34e13d75bf4e9837fedf",
      "name": "Hair",
      "slug": "hair",
      "description": "",
      "thumbnailDescription": "",
      "additionalText": "",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/hair.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/Female_Hair_Rearview_732x549-thumbnail-1.webp",
      "order": 8,
      "metaTitle": "",
      "metaDescription": "",
      "metaHeader": "",
      "subCategories": [
        {
          "id": "63da350e3d75bf4e9837fee1",
          "name": "Hair oil",
          "slug": "hair-hair-oil",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/hair2.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/Female_Hair_Rearview_732x549-thumbnail-1.webp",
          "order": 2,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": "",
          "subCategories": null
        },
        {
          "id": "63db4ed33d75bf4e9837ff93",
          "name": "Leave-in Spray",
          "slug": "hair-leave-in-spray",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/hair3.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/Female_Hair_Rearview_732x549-thumbnail-1.webp",
          "order": 3,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": "",
          "subCategories": null
        },
        {
          "id": "63db4ee53d75bf4e9837ff94",
          "name": "Heat Spray",
          "slug": "hair-heat-spray",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/hair3.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/Female_Hair_Rearview_732x549-thumbnail-1.webp",
          "order": 4,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": "",
          "subCategories": null
        }
      ]
    },
    {
      "id": "63da35353d75bf4e9837fee2",
      "name": "Perfume",
      "slug": "perfume",
      "description": "",
      "thumbnailDescription": "",
      "additionalText": "",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/perfume3.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (6).jpeg",
      "order": 4,
      "metaTitle": "Perfume",
      "metaDescription": "",
      "metaHeader": "Perfume",
      "subCategories": [
        {
          "id": "63da358e3d75bf4e9837fee3",
          "name": " Men's perfume",
          "slug": "perfume-men-s-perfume",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/perfume2.png",
          "thumbnailUrl": "",
          "order": 1,
          "metaTitle": "Men's perfume",
          "metaDescription": "",
          "metaHeader": "Men's perfume",
          "subCategories": null
        },
        {
          "id": "63da35bf3d75bf4e9837fee4",
          "name": "Women's perfume",
          "slug": "perfume-women-s-perfume",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/perfume.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/images (6).jpeg",
          "order": 2,
          "metaTitle": "Women's perfume",
          "metaDescription": "",
          "metaHeader": "Women's perfume",
          "subCategories": null
        }
      ]
    },
    {
      "id": "63da45343d75bf4e9837fef4",
      "name": "Interior",
      "slug": "interior",
      "description": "It is the details that make the whole of a home. With the right interior details, you can easily create a personal and inspiring environment to both enjoy and live in.",
      "thumbnailDescription": "",
      "additionalText": "",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/v__rens-inredningstrender-2023-f__rgstark-inredning-gul-vas-knabstrup-r__fflad-vit-prickig-kopp-freckle-scandi-living-gul-la.webp",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/41059-02-02-33934a97a4.webp",
      "order": 5,
      "metaTitle": "Interior",
      "metaDescription": "",
      "metaHeader": "Interior",
      "subCategories": [
        {
          "id": "63da45493d75bf4e9837fef5",
          "name": "Lighting",
          "slug": "interior-lighting",
          "description": "Lighting is an important part of the interior, to create a pleasant atmosphere from floor to ceiling. Here you will find a wide selection of both functional and decorative lighting for all rooms in the home, and the occasional iconic design lamp from well-known brands.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/flowerpot_vp9_greybeige_miljo-98dd097709.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/46862-03_6_EnvironmentImage-f6440459f2.webp",
          "order": 1,
          "metaTitle": "Lighting",
          "metaDescription": "",
          "metaHeader": "Lighting",
          "subCategories": null
        },
        {
          "id": "63da5e933d75bf4e9837ff2a",
          "name": "Furniture",
          "slug": "interior-furniture",
          "description": "Let yourself be inspired by our handpicked range of furniture. We have designer furniture in Scandinavian style for all rooms of the home from several well-known brands!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/Knitting-loungefåtölj-miljo3-4e129db6cb.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/503172-01_10_EnvironmentImage-621abe10bc.webp",
          "order": 2,
          "metaTitle": "Furniture",
          "metaDescription": "",
          "metaHeader": "Furniture",
          "subCategories": null
        },
        {
          "id": "63da5f433d75bf4e9837ff33",
          "name": "Decoration",
          "slug": "interior-decoration",
          "description": "With decorations and interior details, you can change and renew your home in an easy way. In our assortment you will find interior details for all rooms in the home!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/41059-02-02-33934a97a4.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/43601-03-03-dde13931f0.webp",
          "order": 4,
          "metaTitle": "Decoration",
          "metaDescription": "",
          "metaHeader": "Decoration",
          "subCategories": null
        },
        {
          "id": "63da5f5b3d75bf4e9837ff35",
          "name": "Candlesticks & Lanters",
          "slug": "interior-candlesticks-lanters",
          "description": "Candles are a real mood enhancer. With candlesticks and lanterns you create cozier rooms to socialize and be in. Here we have collected both classics and trendy variants!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/44578-02-02-5b3489487f.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/44578-02-04-7a8721fdd1.webp",
          "order": 5,
          "metaTitle": "Candlesticks & Lanters",
          "metaDescription": "",
          "metaHeader": "Candlesticks & Lanters",
          "subCategories": null
        },
        {
          "id": "63da5f6e3d75bf4e9837ff36",
          "name": "Storage",
          "slug": "interior-storage",
          "description": "A workplace must be pleasant, inspiring and practical. With us you will find everything you need to create a work environment that suits both your style and your needs.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/43527-03-03-8bf1b581cb.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/43601-03-01-be2440b4b0.webp",
          "order": 7,
          "metaTitle": "Storage",
          "metaDescription": "",
          "metaHeader": "Storage",
          "subCategories": null
        },
        {
          "id": "63da5f863d75bf4e9837ff37",
          "name": "Mirrors",
          "slug": "interior-mirrors",
          "description": "A mirror is both a practical and decorative interior detail that is needed in every home. Here we have collected a number of different variants, in different shapes and designs that are suitable for all rooms in the home.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_32098-02-02-7cb5f834b6.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_32098-02-02-7cb5f834b6.webp",
          "order": 8,
          "metaTitle": "Mirrors",
          "metaDescription": "",
          "metaHeader": "Mirrors",
          "subCategories": null
        },
        {
          "id": "63da5f913d75bf4e9837ff38",
          "name": "Paintings & Posters",
          "slug": "interior-paintings-posters",
          "description": "Add a personal touch to your home with a poster, or other wall art. Here you will find a carefully selected assortment with motifs for every room and corner of the home!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/26158-01-03-0a3b59912e.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/26158-01-03-0a3b59912e.webp",
          "order": 6,
          "metaTitle": "Paintings & Posters",
          "metaDescription": "",
          "metaHeader": "Paintings & Posters",
          "subCategories": null
        }
      ]
    },
    {
      "id": "63da5b003d75bf4e9837ff07",
      "name": "Textiles",
      "slug": "textiles",
      "description": "To make the home cosy, warm and welcoming, fabric and textiles are important to decorate with. With us you will find timeless and trendy textiles for all tastes!",
      "thumbnailDescription": "",
      "additionalText": "",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/47117-01-03-d93b04edb9.webp",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/47117-01-03-d93b04edb9.webp",
      "order": 6,
      "metaTitle": "Textiles",
      "metaDescription": "",
      "metaHeader": "Textiles",
      "subCategories": [
        {
          "id": "63da5b0c3d75bf4e9837ff08",
          "name": "Bedding",
          "slug": "textiles-bedding",
          "description": "Soft and comfortable bedding is an important part of a good night's sleep. Feel free to combine comfort and quality with stylish design to create a lovely and inviting bedroom!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_29583-01-02-1a129ab771.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_29583-01-02-1a129ab771.webp",
          "order": 2,
          "metaTitle": "Bedding",
          "metaDescription": "",
          "metaHeader": "Bedding",
          "subCategories": null
        },
        {
          "id": "63da5b163d75bf4e9837ff09",
          "name": "Blankets & Plaids",
          "slug": "textiles-blankets-plaids",
          "description": "A stylish blanket or warming throw is a must on the sofa. The plaid is not only a decorative detail, but is also perfect to wrap around yourself when the cold creeps in!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_29449-03-02-6ea92162d4.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_29449-03-02-6ea92162d4.webp",
          "order": 3,
          "metaTitle": "Blankets & Plaids",
          "metaDescription": "",
          "metaHeader": "Blankets & Plaids",
          "subCategories": null
        },
        {
          "id": "63da5b263d75bf4e9837ff0a",
          "name": "Fabrics",
          "slug": "textiles-fabrics",
          "description": "With fabrics and textiles, you can easily create a personal and cozy home. Choose from well-known patterns and create your own cushion covers, tablecloths or curtains",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/p_21673-04-01-f540414ab7.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/21673-20-01-fc53608ceb.jpeg",
          "order": 4,
          "metaTitle": "Fabrics",
          "metaDescription": "",
          "metaHeader": "Fabrics",
          "subCategories": null
        },
        {
          "id": "63da5b313d75bf4e9837ff0b",
          "name": "Tablecloths",
          "slug": "textiles-tablecloths",
          "description": "With soft elements in the form of table textiles, you create an inviting table setting. Let placemats, runners and tablecloths brighten the table at both the everyday dinner and the festive meal!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/506960-01_6_EnvironmentImage-d097365e96.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/506960-01_7_EnvironmentImage-7711fe33f7.webp",
          "order": 5,
          "metaTitle": "Tablecloths",
          "metaDescription": "",
          "metaHeader": "Tablecloths",
          "subCategories": null
        },
        {
          "id": "63da5b4f3d75bf4e9837ff0c",
          "name": "Towels",
          "slug": "textiles-towels",
          "description": "With nice and fresh towels, you give the bathroom a luxurious and inviting feeling. Here you can revel in color, patterns and lovely materials to find just your favourites!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/44391-13-02-36307a0291.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/44391-13-02-36307a0291.webp",
          "order": 6,
          "metaTitle": "Towels",
          "metaDescription": "",
          "metaHeader": "Towels",
          "subCategories": null
        },
        {
          "id": "63da5e823d75bf4e9837ff29",
          "name": "Carpets",
          "slug": "textiles-carpets",
          "description": "Nothing creates as much comfort as a carpet on the floor. A rug is an important part of the interior design and, in addition to warmth, can contribute with lovely color, texture and pattern!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/504764-01_3_EnvironmentImage-2e562d959b.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/46381-02-03-8cff2ce343.webp",
          "order": 7,
          "metaTitle": "Carpets",
          "metaDescription": "",
          "metaHeader": "Carpets",
          "subCategories": null
        },
        {
          "id": "63da5eb53d75bf4e9837ff2c",
          "name": "Curtains",
          "slug": "textiles-curtains",
          "description": "With curtains you can change and renew the style of the room. We have curtains in various models, colors and patterns so that you can easily find one that fits your home!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/514319-01_4_EnvironmentImage-34a02c4721.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/38076-03-02-5a782efbe8.webp",
          "order": 8,
          "metaTitle": "Curtains",
          "metaDescription": "",
          "metaHeader": "Curtains",
          "subCategories": null
        },
        {
          "id": "63da60783d75bf4e9837ff3f",
          "name": "Pillows & Pillowcases",
          "slug": "textiles-pillows-pillowcases",
          "description": "With cushion covers and decorative pillows, you can quickly and easily change the impression in a room. Here you can choose to mix and match as you like, only your imagination sets the limits!",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/511852-01_3_EnvironmentImage-216e5e07d2.webp",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_0000/categories/511852-01_1_ProductImageMain-380023371a.webp",
          "order": 1,
          "metaTitle": "Pillows & Pillowcases",
          "metaDescription": "",
          "metaHeader": "Pillows & Pillowcases",
          "subCategories": null
        }
      ]
    },
    {
      "id": "672dda1ec4060f0caeee330e",
      "name": "Other",
      "slug": "other",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": null,
      "thumbnailUrl": null,
      "order": 9,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    }
  ],
  "analytics": {
    "gtmId": "GTM-W22M694G",
    "destinations": [
      {
        "type": "GA4",
        "id": "G-B0YQHSTQ27",
        "customMapping": null
      }
    ],
    "mode": null,
    "loadStrategy": null,
    "scriptOrigin": null,
    "sendPageView": null
  },
  "privacy": {
    "cmpType": null,
    "cmpId": null,
    "manageConsentDefaults": null,
    "defaultConsent": null
  },
  "assistant": {
    "id": null,
    "name": null,
    "imgUrl": null,
    "company": "Demo Store"
  },
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "62b43c83052ce417910c112a",
      "name": "Delivery 1",
      "label": "1-3 days",
      "buyable": true
    }
  ],
  "language": "en",
  "currency": "SEK",
  "labels": {
    "assistantChatWith": "Chat with",
    "assistantChatWithFallback": "Customer",
    "assistantShrink": "Shrink",
    "assistantExpand": "Expand",
    "assistantMinimize": "Minimize",
    "assistantReply": "Reply",
    "assistantStatusSent": "Sent",
    "assistantErrorServiceUnavailable": "Service unavailable",
    "assistantErrorUndelivered": "Undelivered",
    "assistantConversationStatusRecording": "Listening...",
    "assistantConversationStatusProcessing": "Processing...",
    "assistantConversationStatusProcessingResponse": "Preparing response...",
    "assistantConversationStatusProcessingResponding": "Responding...",
    "assistantConversationStatusError": "Something went wrong",
    "changePwdFormMsg": "At least 6 characters, including an uppercase letter, a lowercase letter, and a number.",
    "changePwdFormOldPwd": "Old password",
    "changePwdFormOldPwdRequired": "Old password is required.",
    "changePwdFormNewPwd": "New password",
    "changePwdFormNewPwdInvalid": "Password must be at least 6 characters and include an uppercase letter, a lowercase letter, and a number.",
    "changePwdFormRepeatPwd": "Repeat password",
    "changePwdFormRepeatPwdMismatch": "Passwords do not match.",
    "changePwdFormBtnLabel": "Save",
    "changePwdFormBtnLoading": "Saving…",
    "loginFormBtnLoading": "Signing in…",
    "loginFormEmailInvalid": "Enter a valid email address.",
    "loginFormPwdRequired": "Password is required.",
    "loginPageSubtitle": "Log in to view your orders and manage your profile.",
    "loginPageNewHere": "New here?",
    "signupFormBtnLoading": "Registering…",
    "signupFormEmailInvalid": "Enter a valid email address.",
    "signupFormFirstNameRequired": "First name is required.",
    "signupFormLastNameRequired": "Last name is required.",
    "signupPageSubtitle": "Register to follow orders and manage your details.",
    "signupAlreadyHaveAccount": "Already have an account?",
    "magicLinkFormBtnLoading": "Sending…",
    "magicLinkFormEmailInvalid": "Enter a valid email address.",
    "newPasswordPageSubtitle": "Enter your email address and we'll send you a reset link.",
    "newPasswordPageSuccess": "If the email exists in our system, a reset link has been sent to it.",
    "loginForgottenPwd": "Forgotten password?",
    "loginForgottenPwdDesc": "An account is created automatically for you when you place your first order and instructions sent with your order confirmation.",
    "toLogin": "Back to login",
    "requestPwd": "Request new password",
    "accountRegistration": "To be able to follow this and other orders more easily, you can create a password for the account.",
    "contactUsFormName": "Name",
    "contactUsFormPhone": "Phone",
    "contactUsFormEmail": "Email",
    "contactUsFormOrderDate": "Order date",
    "contactUsFormProduct": "Product",
    "contactUsFormOrderNumber": "OrderNumber",
    "contactUsFormDescription": "Description",
    "contactUsFormLocation": "Location",
    "contactUsFormBtnLabel": "Send",
    "contactUsFormAttachFiles": "Attach files",
    "contactConfirmationMessage": "Thank you for submitting your request! We will contact you as soon as possible.",
    "discountFormName": "Do you want to add a discount code?",
    "discountFormBtnLabel": "Add discount",
    "discountFormCodePlaceholder": "Discount code",
    "discountFormErrorNotFound": "Invalid discount code",
    "loginPageTitle": "Log in",
    "loginFormEmail": "Email",
    "loginFormPwd": "Password",
    "loginFormBtnLabel": "Login",
    "magicLinkFormEmail": "Email",
    "magicLinkFormBtnLabel": "Email",
    "profileFormFirstName": "First name",
    "profileFormMiddleName": "Middle name",
    "profileFormLastName": "Last name",
    "profileFormOrganizationName": "Organization name",
    "profileFormGender": "Gender",
    "profileFormDateOfBirth": "Birthdate",
    "profileFormBtnLabel": "Send",
    "logout": "Logout",
    "accountUserGreeting": "Welcome",
    "accountHandlerAccountTitle": "Account",
    "accountHandlerOrdersTitle": "Orders",
    "accountHandlerProfileTitle": "Profile",
    "accountHandlerChangePasswordTitle": "Change password",
    "customerOrderOrderNumber": "Order number",
    "customerOrderPaymentDate": "Payment date",
    "customerOrderStatus": "Status",
    "customerOrderShippingCost": "Shipping cost",
    "customerOrderDiscount": "Discount",
    "customerOrderAmount": "Amount",
    "customerOrderDetailInformation": "Information",
    "customerOrderDetailDeliveryAddress": "Delivery address",
    "customerOrderDetailAddress": "Address",
    "customerOrderDetailPostalCode": "Post code",
    "customerOrderDetailAttention": "Attention",
    "customerOrderDetailMobile": "Mobile",
    "customerOrderDetailYourOrder": "Your order",
    "customerOrderDetailPcs": "pcs",
    "noOrdersMessage": "No orders found",
    "noOrdersBtnLabel": "Continue shopping",
    "emptyCart": "No items found",
    "cartServiceShowDetails": "Show details",
    "cartServiceHideDetails": "Hide details",
    "allCategoriesTitle": "All categories",
    "subcategoriesShowMoreBtnLabel": "More",
    "subcategoriesNoCategories": "No categories found",
    "subcategoriesToolbarTitle": "Categories",
    "allCategoriesListDynamic": "Category",
    "checkoutNewsLetter": "Feel free to subscribe to our newsletter to receive updates about our products and special offers: ",
    "newsLetterInputLabel": "Your email",
    "emptyCartBtnLabel": "Start shopping",
    "continueShopping": "Continue shopping",
    "checkoutCartCartItemsMsg": "products in cart",
    "checkoutPageTitle": "Checkout",
    "checkoutServicesHeading": "Services",
    "addToCart": "Add to cart",
    "noServices": "No services",
    "cartTotal": "Cart total",
    "cartToCheckout": "Cart checkout",
    "checkoutSummaryDiscount": "Discount",
    "checkoutSummarySummaryItemProducts": "Products",
    "checkoutSummarySummaryItemServices": "Services",
    "checkoutSummaryCompletePayment": "Complete payment",
    "checkoutSummaryNoProducts": "No products found in the cart",
    "checkoutSummaryDiscountMsg": "Important: If the price of the item is already discounted, it can only have an effect on the original price of the item.",
    "checkoutSummarySummaryTotal": "Total",
    "checkoutSummarySummaryTotalDiscount": "Total discount",
    "checkoutSummaryQuantityDiscount": "Quantity discount",
    "quantityDiscountTeaser": "Buy {{nextQty}} and save {{nextPercentage}} on your whole order.",
    "quantityDiscountTeaserPack": "Buy {{nextQty}} and save {{nextPercentage}} on every pack.",
    "quantityDiscountProgress": "Add {{unitsToNext}} more and save {{nextPercentage}} on your whole order.",
    "quantityDiscountProgressPack": "Add {{unitsToNext}} more to get {{nextPercentage}} off another {{nextQty}}.",
    "quantityDiscountAchieved": "You save {{currentPercentage}} on this item.",
    "quantityDiscountSavingPerUnit": "You save {{nextSaving}}/{{unit}}",
    "quantityDiscountUnitAbbr": "pcs",
    "checkoutSummarySummaryVat": "VAT",
    "checkoutSummarySummaryNetTotal": "Subtotal excl. VAT",
    "checkoutSummarySummaryContinueToPayment": "Continue to payment",
    "checkoutSummaryCountryLabel": "Country",
    "checkoutDeliveryStep": "Delivery",
    "checkoutPaymentStep": "Complete your order",
    "confirmationPageRedirectBtnLabel": "My pages",
    "confirmationPageUnknownError": "Unknown error",
    "orderIdNotFound": "Order ID not found",
    "klarnaBackToCart": "Back to cart",
    "productFilesFileLabel": "document",
    "updateCart": "Update",
    "productDetailDeliveryLabelUnavailable": "not available",
    "previousPageBtnLabel": "go back",
    "productRequest": "Product request",
    "productListItemBuyToDetails": "Go to detail",
    "productNotActive": "This product is not active",
    "articleNumber": "Article Number",
    "gtin": "GTIN",
    "brand": "Brands",
    "brandsTitle": "Brands",
    "stockLevel": "Stock level",
    "unit": "units",
    "productTabsDescriptionTitle": "Description",
    "productTabsSpecificationTitle": "Specification",
    "productTabsAttachedFilesTitle": "Attached files",
    "productTabsNoDescription": "No description",
    "productTabsReviewsTitle": "Reviews",
    "notInStock": "Not available in stock",
    "noMedias": "No photos",
    "withMedias": "See photos",
    "accessories": "Accessories",
    "variants": "Variants",
    "variantNotFound": "Variant not found",
    "showMoreBtnLabel": "More",
    "priceTitle": "Price",
    "moreFiltersTitle": "More",
    "reset": "Reset filters",
    "cleanFilters": "Clean",
    "search": "Search",
    "sort": "Sort",
    "showMoreFilters": "Show more filters",
    "filterTitle": "Filter",
    "filterCategoriesTitle": "Category",
    "filterBrandsTitle": "Brand",
    "filterPriceRangeTitle": "Price",
    "filterClear": "Reset filters",
    "filterSubmitText": "Show products",
    "filterRangeSelectorFrom": "From",
    "filterRangeSelectorTo": "to",
    "productListVerticalTitle": "Sort and filter",
    "productListSearchTitle": "Sort and filter",
    "viewTotalProducts": "see products",
    "noProductsFound": "No products found",
    "removeFilter": "Remove filter",
    "uniqueOption": "Unique",
    "notValuesFound": "No values found",
    "sortAndFilter": "Sort and filter",
    "dropzoneDropMsg": "Drop your files here or click to upload",
    "dropzoneAcceptedFiles": "Accepted files",
    "dropzoneReadyMsg": "Ready to upload",
    "dropzoneRejectedMsg": "Rejected files",
    "prisFilterTitle": "Price",
    "searchPlaceholder": "Search products",
    "followUs": "Follow us",
    "searchPanelCloseSearch": "Close search",
    "searchPanelOpenSearch": "Open search",
    "searchPopularResults": "Popular results:",
    "registerAccount": "Register",
    "signupFormEmail": "Email",
    "signupFormFirstName": "First name",
    "signupFormLastName": "Last name",
    "signupFormBtnLabel": "Signup",
    "signUpSuccessMsg": "The account has been registered, you will receive an email shortly with instructions.",
    "signUpErrorMsgRecoverPassword": "Have you lost your password? Recover it ",
    "signupRecoverPasswordLink": "here",
    "signupInvalidCredentials": "Invalid credentials",
    "marketplaceProductsIsAvailable": "Available",
    "marketplaceProductsIsNotAvailable": "Not available",
    "marketplaceProductsShowMore": "Show more",
    "marketplaceProductsShowLess": "Show less",
    "marketplaceProductsNoVendorsFound": "No vendors found",
    "showAll": "Show all",
    "seeAll": "See all",
    "requestSent": "Request sent",
    "mobileMenuMultiColumnBack": "Back",
    "mobileMenuMultiColumnSearchPlaceholder": "Search for product or service",
    "checkoutRemoveDiscountCode": "Remove discount code",
    "quantity": "Quantity",
    "assistantChat": "Chat",
    "assistantOffers": "Deals",
    "vatToggleIncludedLabel": "Incl. VAT",
    "vatToggleExcludedLabel": "Excl. VAT",
    "vatToggleBusinessPricingLabel": "Business pricing",
    "accountSignInLabel": "Sign in",
    "accountMyAccountFallback": "My account",
    "accountMyPages": "My orders",
    "accountProfile": "Profile",
    "accountLogout": "Log out",
    "accountNewHere": "New here?",
    "accountCreateAccount": "Create account",
    "accountViewPricesHeading": "View prices",
    "accountBusinessBadge": "Business account",
    "ordersListTitle": "All orders",
    "ordersListRangeOf": "of",
    "ordersListEmpty": "You don't have any orders yet.",
    "ordersListError": "We could not load your orders right now. Please try again later.",
    "ordersListEmptyCta": "Continue shopping",
    "ordersListItemQuantity": "Qty:",
    "ordersListItemMore": "more",
    "ordersListOrderIdPrefix": "Order ID:",
    "ordersListDetailsCta": "View details →",
    "ordersListPlacedBy": "Placed by",
    "ordersListPlacedByUnknown": "Unknown",
    "orderDetailBack": "← Back to orders",
    "orderDetailOrderedOn": "Ordered",
    "orderDetailOrderedOnBy": "by",
    "orderDetailPlacedByUnknown": "Unknown",
    "orderDetailShippingAddress": "Shipping address",
    "orderDetailBillingAddress": "Billing address",
    "orderDetailProductsHeading": "Products",
    "orderDetailShipping": "Shipping",
    "orderDetailDiscount": "Discount",
    "orderDetailTotal": "Total",
    "orderDetailVatIncluded": "Of which VAT",
    "orderDetailShipmentsHeading": "Shipments",
    "orderDetailShipmentTracking": "Tracking",
    "orderDetailShipmentPickup": "Pickup location",
    "orderDetailShipmentEstimated": "Estimated delivery",
    "orderDetailShipmentShipped": "Shipped",
    "orderDetailShipmentDelivered": "Delivered",
    "orderDetailShipmentItems": "Items",
    "orderDetailProductUnavailable": "No longer available",
    "profileFormSectionTitle": "Personal details",
    "profileFormFirstNameLabel": "First name",
    "profileFormFirstNameRequired": "First name is required",
    "profileFormMiddleNameLabel": "Middle name",
    "profileFormLastNameLabel": "Last name",
    "profileFormLastNameRequired": "Last name is required",
    "profileFormOrganizationNameLabel": "Organization name",
    "profileFormDateOfBirthLabel": "Date of birth",
    "profileFormGenderLabel": "Gender",
    "profileFormGenderPlaceholder": "Select…",
    "profileFormGenderFemale": "Female",
    "profileFormGenderMale": "Male",
    "profileFormGenderUndefined": "Prefer not to say",
    "profileFormEmailLabel": "Email",
    "profileFormPhoneLabel": "Phone",
    "profileFormPhonePlaceholder": "+46…",
    "profileFormPhoneInvalid": "Enter a valid phone number.",
    "profileFormSubmit": "Save",
    "profileFormSubmitLoading": "Saving…",
    "profileFormSuccess": "Profile updated",
    "profileFormGenericError": "Something went wrong",
    "changePasswordFormSectionTitle": "Change password",
    "changePasswordFormOldLabel": "Current password",
    "changePasswordFormOldRequired": "Current password is required",
    "changePasswordFormNewLabel": "New password",
    "changePasswordFormNewDescription": "At least 6 characters, including an uppercase letter, a lowercase letter, and a number.",
    "changePasswordFormNewInvalid": "Password must be at least 6 characters and include an uppercase letter, a lowercase letter, and a number.",
    "changePasswordFormConfirmLabel": "Confirm new password",
    "changePasswordFormConfirmRequired": "Confirm the new password",
    "changePasswordFormMismatch": "Passwords do not match",
    "changePasswordFormMissingEmail": "Logged-in account is missing an email",
    "changePasswordFormSubmit": "Update password",
    "changePasswordFormSubmitLoading": "Updating…",
    "changePasswordFormSuccess": "Password updated",
    "changePasswordFormGenericError": "Something went wrong",
    "paginationPrev": "Previous",
    "paginationNext": "Next",
    "accountSidebarLogout": "Log out",
    "accountNavOrders": "Orders",
    "accountNavProfile": "Profile",
    "accountNavPassword": "Password",
    "accountMetaOrdersTitle": "My orders",
    "accountMetaOrderDetailTitle": "Order",
    "accountMetaProfileTitle": "Profile",
    "accountMetaPasswordTitle": "Password",
    "ordersListItemShowLess": "Show less",
    "orderDetailShipmentPickedUp": "Picked up",
    "orderDetailPaymentInvoiced": "Invoice",
    "orderDetailPaymentVia": "Paid via",
    "paymentProviderKlarna": "Klarna",
    "paymentProviderNexi": "Nexi",
    "paymentProviderSvea": "Svea",
    "paymentProviderLedyer": "Ledyer",
    "paymentProviderQliro": "Qliro",
    "paymentProviderBriqpay": "Briqpay",
    "orderStatusDraft": "Draft",
    "orderStatusCreated": "Created",
    "orderStatusPaid": "Paid",
    "orderStatusProcessing": "Processing",
    "orderStatusReady": "Ready",
    "orderStatusPartiallyDelivered": "Partially delivered",
    "orderStatusDelivered": "Delivered",
    "orderStatusPartiallyReturned": "Partially returned",
    "orderStatusReturned": "Returned",
    "orderStatusCancelled": "Cancelled",
    "orderStatusSettled": "Settled",
    "shipmentStatusCreated": "Created",
    "shipmentStatusProcessing": "Processing",
    "shipmentStatusShipped": "Shipped",
    "shipmentStatusDelivered": "Delivered",
    "shipmentStatusBlocked": "Blocked",
    "shipmentStatusCancelled": "Cancelled",
    "shipmentStatusDeleted": "Deleted",
    "invoiceBillingFieldFirstName": "First name",
    "invoiceBillingFieldLastName": "Last name",
    "invoiceBillingFieldEmail": "Email",
    "invoiceBillingErrorRequired": "Required field",
    "invoiceBillingErrorEmail": "Invalid email address",
    "confirmationSummaryHeading": "Your order",
    "confirmationSummaryQuantity": "Quantity",
    "confirmationSummaryShipping": "Shipping",
    "confirmationSummaryShippingFree": "Free shipping",
    "confirmationSummaryDiscount": "Discount",
    "confirmationSummaryVat": "Of which VAT",
    "confirmationSummaryTotal": "Total",
    "confirmationSummaryShippingAddress": "Delivery address",
    "confirmationSummaryPickup": "Pickup location",
    "confirmationSummaryTracking": "Track your shipment",
    "confirmationSummaryPaymentMethod": "Payment method",
    "briqpayConfirmationTitle": "Thank you for your order!",
    "briqpayConfirmationOrderNumberPrefix": "Order number: ",
    "briqpayConfirmationPending": "Your payment is being processed and will be confirmed shortly.",
    "confirmationSummaryReceiptEmail": "Email",
    "invoiceBillingErrorPhone": "Invalid phone number",
    "currency": "SEK",
    "priceCurrency": "SEK"
  },
  "paths": {
    "brandsUrlPath": "/brands",
    "categoriesUrlPath": "/categories",
    "tagsUrlPath": "/tags",
    "productsUrlPath": "/products",
    "blogsUrlPath": "/blog"
  },
  "staticLinks": [
    {
      "id": "brands",
      "label": "Brands",
      "path": "/brands"
    },
    {
      "id": "blog",
      "label": "Blog",
      "path": "/blog"
    },
    {
      "id": "minasidor",
      "label": "My page",
      "path": "/account"
    }
  ],
  "logoUrl": "https://storage.googleapis.com/gecko-media/EC_0000/granditude_logo.png",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Price high-low",
      "default": false
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Price low-high",
      "default": true
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Newest",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "45vw",
  "maxContentWidth": "1600",
  "menuMaxContentWidth": "1600",
  "sliderDefaultValues": [
    0,
    200000
  ],
  "freeShippingOver": 499,
  "shippingProviderConfig": {
    "provider": "DEFAULT",
    "simpleShipping": {
      "minimumOrderAmountForFreeDelivery": 499,
      "deliveryFee": 139
    }
  },
  "paymentProviderConfig": {
    "providerName": "KLARNA",
    "providerOptions": {
      "klarna": {
        "purchaseCurrency": "SEK"
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 200000,
  "topNavHeight": {
    "panel": {
      "base": 0,
      "sm": "5vh"
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "19vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": [
    {
      "label": "Facebook",
      "icon": "FACEBOOK",
      "href": "https://www.facebook.com/granditude/?locale=sv_SE"
    },
    {
      "label": "Instagram",
      "icon": "INSTAGRAM",
      "href": "https://www.instagram.com/granditude/?hl=en"
    }
  ],
  "topNavPanel": {
    "items": [
      {
        "icon": "FaCrown",
        "label": "About us",
        "href": "/about"
      },
      {
        "icon": "MdOutlineLocalShipping",
        "label": "Free shipping"
      },
      {
        "icon": "FaCrown",
        "label": "Our showrooms",
        "href": "/showrooms"
      }
    ]
  }
};
export const serverTheme = {
  "colors": {},
  "components": {
    "GrandOverlay": {
      "bg": "rgba(0,0,0, 0.25)"
    }
  }
}; 
